export default "__VITE_ASSET__yl1fugmZ__"